import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DialogContainer, useMediaQuery } from '@frontierag/frontier-ui-library';
import ProductForm from 'components/OrderWizard/OrderProducts/ProductForm';
import { useFormikContext } from 'formik';
import isEqual from 'lodash/isEqual';

import { styles } from './styles';
import type { IEditProductDialog } from './types';

const EditProductDialog = ({
  open,
  onClose,
  customerReference,
  isDebtOwner,
}: IEditProductDialog) => {
  const { t } = useTranslation('CreateOrder');
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));

  const { submitForm, resetForm, isValid, initialValues, values } = useFormikContext();

  const hasChanges = useMemo(() => {
    return !isEqual(initialValues, values);
  }, [initialValues, values]);

  const saveButtonAction = useMemo(
      () => ({
        title: t('viewBasket.dialog.saveBtn'),
        onActionClick: submitForm,
        disabled: !hasChanges || !isValid,
      }),
      [hasChanges, isValid, submitForm, t],
    ),
    dialogActions = [saveButtonAction];

  const handleClose = useCallback(() => {
    onClose();
    setTimeout(() => resetForm(), 500);
  }, [onClose, resetForm]);

  return (
    <DialogContainer
      open={open}
      onClose={handleClose}
      title={t('viewBasket.dialog.title')}
      closeLabel={t('viewBasket.dialog.cancelBtn')}
      actions={dialogActions}
      sx={isMobile ? styles.dialogMobile : styles.dialogDesktop}
    >
      <ProductForm isEdit customerReference={customerReference} isDebtOwner={isDebtOwner} />
    </DialogContainer>
  );
};

export default EditProductDialog;
